module.exports = __webpack_public_path__ + "img/234.fc56a589.jpg";